var _ellipse, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "notification",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.519,
    height: 16.9,
    viewBox: "0 0 15.519 16.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_44",
    "data-name": "Ellipse 44",
    cx: 1.898,
    cy: 1.898,
    rx: 1.898,
    ry: 1.898,
    transform: "translate(5.861 13.104)",
    fill: "#c0321f"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2129",
    "data-name": "Path 2129",
    d: "M200.63,396.975a1.9,1.9,0,0,0-1.89,1.722l2.067,2.067a1.9,1.9,0,0,0-.177-3.788Z",
    transform: "translate(-192.87 -383.871)",
    fill: "#c0321f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2130",
    "data-name": "Path 2130",
    d: "M34.9,354.192H22.46a1.539,1.539,0,0,0,0,3.077H34.9a1.539,1.539,0,1,0,0-3.077Z",
    transform: "translate(-20.921 -342.501)",
    fill: "#c0321f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2131",
    "data-name": "Path 2131",
    d: "M69.769,10.531V7.446a5.332,5.332,0,0,0-4.027-5.169,1.512,1.512,0,1,0-2.607,0,5.332,5.332,0,0,0-4.027,5.169v3.084A1.209,1.209,0,0,1,57.9,11.74H70.978A1.209,1.209,0,0,1,69.769,10.531Zm-5.33-8.415a.6.6,0,1,1,.6-.6A.6.6,0,0,1,64.439,2.116Z",
    transform: "translate(-56.679)",
    fill: "#c0321f"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2132",
    "data-name": "Path 2132",
    d: "M21.5,410.067a1.423,1.423,0,0,0,1.519,1.227H35.461a1.423,1.423,0,0,0,1.519-1.227Z",
    transform: "translate(-21.481 -396.531)",
    fill: "#c0321f"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2133",
    "data-name": "Path 2133",
    d: "M348.137,234.811v1.778l-2.367-2.367h.009a.528.528,0,0,1,.339.1,2.715,2.715,0,0,0,1.6.519A2.767,2.767,0,0,0,348.137,234.811Z",
    transform: "translate(-335.047 -226.489)",
    fill: "#c0321f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.80aae66186aa8e8460d1729a240889b8.svg";
export { ForwardRef as ReactComponent };